export default async function ({app, store, route, auth, redirect}) {
  console.log("redirect route.path",route.path);
  if (!store.state.auth.loggedIn && route.path !== "/login" 
    && route.path !== "/forgot-password" 
    && route.path !== "/reset-password"
    && route.path !== "/register"
    && route.path !== "/insights/" 
    && route.path !== "/privacy" 
    && route.path !== "/legal-notice" 
   ) {
    return redirect('/login');
  }
}
